import axiosInstance from './axios.service'
import type { PentaError } from '@/utils/PentaError'

export default { save }

// Persiste un error de frontend puro (que no vino ya guardado por el backend) en /api/errorLog, ver src/api/errorLog.api.js
async function save(error: PentaError): Promise<{ _id: string, ts: string, randId: string }> {
  const result = await axiosInstance.post('/api/errorLog', {
    message: error.message,
    name: error.name,
    source: error.source,
    stack: error.stack,
    extraInfo: error._extraInfo,
    user: { enterprise: window.profile?.enterprise },
    browser: `${window.navigator.vendor || 'unknown'} - ${window.navigator.userAgent}`,
    _controller: 'vue.errorHandler',
    _ignoreVeil: true
  })
  return result.data
}
